import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
const FORMAT = {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false};
const LOCALES = {ru: 'ru-RU', bs: 'ru-RU', en: 'en-GB', ch: 'zh-CN'};
const EMPTY = '';
@Pipe({name: 'workflowTimestamp'})
export class WorkflowTimestampPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}
  transform(value: string, zone: string): string {
    if (!value) { return EMPTY; }
    const options = Object.assign({}, FORMAT, {timeZone: zone});
    try { return new Intl.DateTimeFormat(LOCALES[this.translate.currentLang] || LOCALES.en, options).format(new Date(value)); }
    catch (error) { return value; }
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/pipes/workflow-timestamp.pipe.ts